<template>
  <div class="categories">
    <v-card-text>
      <v-row>
        <v-col cols="12 col-sm-6 col-md-4 col-lg-3" @click="goToDetail(obj.CanonicalUrl)" class="blog-post"
               v-for="obj in blog_data">
          <article class="article">
            <p :href="obj.CanonicalUrl" :title="obj.PageTitle">
              <img :alt="obj.PageTitle" width="100%" height="auto"
                   :src="obj.ImageUrl.replace('http://', 'https://')"
                   class="attachment-blog-thumb size-blog-thumb wp-post-image"
                   />
            </p>
            <div class="post-body">
              <h4 style='line-height:1.5em;min-height:3em;text-align: center;'>
                <label :href="obj.CanonicalUrl" style="color: white">{{obj.PageTitle}}</label>
              </h4>
              <p></p>
            </div>
          </article>
        </v-col>

      </v-row>

    </v-card-text>
    <infinite-loading @infinite="get_blogs">
      <template slot="no-more">{{ $t('noMorePost') }}</template>
      <template slot="no-results">{{ $t('noResult') }}</template>
      <template slot="spinner">{{ $t('loading') }}</template>

    </infinite-loading>

  </div>
</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading';
  export default {
    components: {
      InfiniteLoading
    },
    data() {
      return {
        blog_data: {},
        isMobile: false,
        selected_item_id: '',
        last_class_name: '',
        errors: [],
        page: 1,
      }
    },
    watch: {},
    mounted() {
      this.get_blogs()
    },
    methods: {
      resize_mobile() {
        if (window.innerWidth < 600) {
          this.isMobile = true
        } else {
          this.isMobile = false
        }
      },
      get_blogs($state) {
        var self = this;
        var send_data = {
          PageNo: this.page
        }
        this.axios.post('https://panel.zoodkomak.com/jetToken/Blog', send_data, {})
          .then(response => {
            if(self.page==1){
              self.blog_data = response.data.items.VmRelatedPageInfos;
            }else{
              // response.data.items.VmRelatedPageInfos.forEach(function(val){
              //    self.blog_data.push(val)
              // });
              self.blog_data.push(...response.data.items.VmRelatedPageInfos);
            }

            if(response.data.items.VmRelatedPageInfos.length>0){
              self.page++;

              $state.loaded();
            }else{
              $state.complete();

            }

          }).catch(e => {
          this.errors.push(e)
        })
      },
goToDetail(url){
        var url_vars = url.split('/');
  console.log("url ",);
  var group = url_vars[url_vars.length-2]
  var keyword = url_vars[url_vars.length-1]

  // this.$router.push({path:'/blog-info/'+group+"/"+keyword})
  window.open("https://blog.zoodkomak.com/pages/" + group + '/' + keyword )


},
      get_item_color(item_id) {
        if (item_id == this.selected_item_id) {
          return '#cee2f7'
        } else {
          return 'white'
        }
      },
      add_request(id, cat_id, title) {
        // if (this.dataset.post_id != null) {
        // localStorage.setItem("RequestPostId", id);
        // localStorage.setItem("RequestPostName", title);
        // localStorage.setItem("RequestPostBrand",cat_id);
        // window.open('/#AddRequest', "_self");
        // var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var passing_data = JSON.parse(localStorage.getItem('request_data'))

        // passing_data.sub_group_id = item_id
        // passing_data.request_name = passing_data.request_name + title + ' '
        passing_data.post_id = id
        passing_data.post_name = title
        passing_data.post_brand_id = cat_id

        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.$router.push({name: 'request_detail', params: {}})

        // this.$router.push({ path: 'brands', params: {} })

        // }
      },
      post_view(id) {
        window.open('https://bilbordz.com/api/view_post/' + id)

      },
      get_categories() {
        // console.log("datas is "+localStorage.getItem('request_data'))
        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var cat_id = passing_data.sub_group_id

        const send_data = {
          groupId: cat_id,
        }
        var formData = new FormData()
        formData.append('groupId', cat_id)
        // this.axios.post('/Register' , send_data,{
        this.axios.post('https://cp.zoodkomak.com/api/get_group_posts', formData, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("response", response);
              // self.fullName = response.data.msg;
              self.items = response.data.posts
              // self.level = 2;
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
</script>
<style>
  .blog-post {
padding: 10px
  }
  .blog-post .article {
    padding: 3px;
    border: 1px solid #cfcdcd;
    border-radius: 5px;
  }


</style>
